import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { useAppSelector } from "redux/store";
import { IUserLoggedState } from "redux/features/loggedUserSlice";
import { useGetACompanyQuery } from "redux/api/companyApi";
import FullScreenLoader from "components/FullScreenLoader";
import { useGetAProvinceQuery } from "redux/api/provinceApi";
import { useGetCompanyAdminQuery } from "redux/api/userApi";
import { useDispatch, useSelector } from "react-redux";
import { usePutOperationMutation } from "redux/api/operationApi";
import { setCurrentOperation } from "redux/features/operationSlice";
import LegalTermsCardEsp from "./LegalTermsCardEsp";
import LegalTermsCardEng from "./LegalTermsCardEng";
import { useIntl } from "react-intl";

const LegalTerms: React.FC<{
  nextStep: () => void;
  previousStep: () => void;
}> = ({ nextStep, previousStep }) => {
  const { locale } = useIntl();
  const dispatch = useDispatch();
  const [isAccepted, setIsAccepted] = useState(false);
  const [error, setError] = useState(false);

  const { user } = useAppSelector(
    (state: { userLoggedState: IUserLoggedState }) => state.userLoggedState
  );
  const operation = useSelector((state: any) => {
    return (
      state.operationState?.currentOperation?.data ||
      state.operationState?.currentOperation
    );
  });

  //api calls
  const [
    updateOperation,
    {
      data: postedOperationData,
      isSuccess: isPostedOperationSuccess,
      error: apiError,
    },
  ] = usePutOperationMutation();
  const {
    data: company,
    error: companyError,
    isLoading: companyIsLoading,
  } = useGetACompanyQuery(user?.companyId as string, {
    skip: !user?.companyId,
  });
  const {
    data: province,
    error: provinceError,
    isLoading: provinceIsLoading,
  } = useGetAProvinceQuery(company?.province as string, {
    skip: !company?.province,
  });


  useEffect(() => {
    if (operation) {
      setIsAccepted(operation.acceptedLegalTerms);
    }
  }, []);


  const handleAccept = () => {
    if (operation.acceptedLegalTerms && isAccepted) {
      nextStep();
      return;
    }
    if (isAccepted) {
      const updatedOperation = {
        ...operation,
        acceptedLegalTerms: true,
      };
      const formData = new FormData();
      formData.append("data", JSON.stringify(updatedOperation));
      updateOperation({ id: operation.id, operationToUpdate: formData });
    } else {
      setError(true);
    }
  };
  if (isPostedOperationSuccess && postedOperationData) {
    dispatch(setCurrentOperation(postedOperationData));
    nextStep();
  }
  if (companyIsLoading || provinceIsLoading ) {
    return <FullScreenLoader />;
  }
  const companyName = company?.name
    ? company.name.charAt(0).toUpperCase() + company.name.slice(1).toLowerCase()
    : "";
  const companyAddressType = `${company?.addressType}/ ${company?.addressName}, 
  ${company?.addressNumber}. ${province?.name} ${company?.postalCode} `;
  const companyAdminMail = company?.email;
  const companyPhone = company?.phoneNumber;
  return (
    <div>
      {locale === 'es' ? <LegalTermsCardEsp
        companyName={companyName}
        companyNif={company?.nif ?? ''}
        companyAddressType={companyAddressType}
        companyMail={companyAdminMail ?? ''}
        companyPhone={companyPhone ?? ''}
        handleAccept={handleAccept}
        error={error}
        apiError={!!apiError}
        isAccepted={isAccepted}
        setIsAccepted={setIsAccepted}
        previousStep={previousStep}


      />
        :
        <LegalTermsCardEng
        companyName={companyName}
        companyNif={company?.nif ?? ''}
        companyAddressType={companyAddressType}
        companyMail={companyAdminMail ?? ''}
        companyPhone={companyPhone ?? ''}
        handleAccept={handleAccept}
        error={error}
        apiError={!!apiError}
        isAccepted={isAccepted}
        setIsAccepted={setIsAccepted}
        previousStep={previousStep}
        />}
    </div>
  );
};
export default LegalTerms;
